// client/src/navigations/index.js

import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AuthNavigation from './authNav';
import AppMainNav from './appMainNav';
import { GlobalContext } from '../context/provider';
import authAction from '../context/actions/authAction';

const AppNavigation = () => {
  const { authState: { isLoggedIn }, authDispatch } = useContext(GlobalContext);
  
  return (
    <Router>
      {/* {isLoggedIn ? <AppMainNav /> : <AuthNavigation />} */}
      <AppMainNav />
    </Router>
  );
};

export default AppNavigation;